import { GA } from '@gamiphy/analytics';

export const trackLoggedIn = (): void => GA.trackEvent('users', 'logged_in');
export const trackSignedUp = (): void => GA.trackEvent('users', 'signed_up');
